'use client';
import { useRouter } from 'next/navigation';
import React from 'react';
import { useUserInfo } from '../../../hooks/useUserInfo';
import type { Config } from 'u-next/config';

/**
 * Logged in user check
 * child component will be kept as Server Component
 */
export const EnsureLoggedIn: React.FC<
  React.PropsWithChildren & {
    config: Config;
    fallback?: React.ReactNode;
  }
> = ({ children, config, fallback = null }) => {
  const router = useRouter();
  const { isLoadedUserInfo, userInfo } = useUserInfo();
  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    if (!isLoadedUserInfo) {
      return;
    }

    if (!userInfo.isLoggedIn) {
      const backUrl = encodeURIComponent(window.location.href);
      router.replace(`${config.ACCOUNT}/login?back=${backUrl}`);
      return;
    }

    setIsReady(true);
  }, [config.ACCOUNT, isLoadedUserInfo, router, userInfo.isLoggedIn]);

  return isReady ? <>{children}</> : <>{fallback}</>;
};
